/* src/app/aichat/chat.component.scss */
:host {
  --chat-radius: var(--border-radius);
  --chat-surface: var(--surface-card);
  --chat-muted: var(--surface-ground);
  --chat-border: var(--surface-border);
  --chat-hover: var(--surface-hover);
  --chat-text: var(--text-color);
  --chat-text-muted: var(--text-color-secondary);
  --chat-primary: var(--primary-color);
  --chat-primary-text: var(--primary-color-text);
  --chat-header-bg:
    linear-gradient(
      
      135deg,
      var(--p-primary-600),
      var(--p-primary-800) );
  --chat-header-fg: var(--p-primary-contrast-color);
  --chat-shadow: 0 10px 40px color-mix(in srgb, var(--chat-text) 10%, transparent);
  --chat-bubble-shadow: 0 2px 12px color-mix(in srgb, var(--chat-text) 6%, transparent);
  --chat-accent-glow: color-mix(in srgb, var(--chat-primary) 10%, transparent);
  --chat-code-bg: color-mix(in srgb, var(--chat-text) 8%, var(--chat-surface));
  --chat-user-code-bg: color-mix(in srgb, var(--chat-primary-text) 18%, transparent);
  --chat-empty-icon-bg: color-mix(in srgb, var(--chat-primary) 12%, var(--chat-surface));
  --chat-empty-icon-border: color-mix(in srgb, var(--chat-primary) 24%, var(--chat-border));
  --chat-error-bg: color-mix(in srgb, var(--p-red-500) 12%, var(--chat-surface));
  --chat-error-border: color-mix(in srgb, var(--p-red-500) 35%, var(--chat-border));
  --chat-error-text: var(--p-red-500);
  --chat-scrollbar: color-mix(in srgb, var(--chat-text) 22%, transparent);
  display: block;
  height: 100%;
}
.chat-shell {
  display: flex;
  flex-direction: column;
  height: 80vh;
  max-width: min(52rem, 92vw);
  margin: 0 auto;
  background: var(--chat-surface);
  border: 1px solid var(--chat-border);
  border-radius: calc(var(--chat-radius) + 0.25rem);
  box-shadow: var(--chat-shadow);
  overflow: hidden;
  color: var(--chat-text);
}
.chat-shell--floating {
  height: 100%;
  max-width: 100%;
  margin: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.chat-shell--page {
  margin-top: 1.5rem;
}
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.125rem;
  background: var(--chat-header-bg);
  border-bottom: 1px solid color-mix(in srgb, var(--chat-header-fg) 14%, transparent);
  flex-shrink: 0;
}
.chat-header-brand {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  min-width: 0;
}
.chat-header-avatar {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  background: color-mix(in srgb, var(--chat-header-fg) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--chat-header-fg) 22%, transparent);
  display: grid;
  place-items: center;
  flex-shrink: 0;
  overflow: hidden;
}
.chat-header-avatar img {
  width: 2rem;
  height: 2rem;
  object-fit: contain;
}
.chat-header-copy {
  min-width: 0;
}
.chat-header-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--chat-header-fg);
  line-height: 1.2;
}
.chat-header-subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.8125rem;
  color: color-mix(in srgb, var(--chat-header-fg) 78%, transparent);
  line-height: 1.3;
}
.chat-header-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}
.chat-header-actions :host ::ng-deep .p-button {
  color: var(--chat-header-fg);
}
.chat-header-actions :host ::ng-deep .p-button:hover:not(:disabled) {
  background: color-mix(in srgb, var(--chat-header-fg) 12%, transparent);
}
.messages-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1.25rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background:
    radial-gradient(
      ellipse 80% 50% at 50% -20%,
      var(--chat-accent-glow),
      transparent),
    var(--chat-muted);
  scroll-behavior: smooth;
}
.messages-container::-webkit-scrollbar {
  width: 0.5rem;
}
.messages-container::-webkit-scrollbar-thumb {
  background: var(--chat-scrollbar);
  border-radius: 999px;
}
.empty-state {
  margin: auto;
  max-width: 18rem;
  text-align: center;
  padding: 2rem 1rem;
}
.empty-state-icon {
  width: 3.5rem;
  height: 3.5rem;
  margin: 0 auto 1rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 1.35rem;
  color: var(--chat-primary);
  background: var(--chat-empty-icon-bg);
  border: 1px solid var(--chat-empty-icon-border);
}
.empty-state-title {
  margin: 0 0 0.5rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--chat-text);
}
.empty-state-text {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--chat-text-muted);
}
.message-row {
  display: flex;
  align-items: flex-end;
  gap: 0.625rem;
  max-width: 92%;
  animation: message-in 0.28s ease-out;
}
.message-row--assistant {
  align-self: flex-start;
}
.message-row--user {
  align-self: flex-end;
}
.message-avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  font-size: 0.85rem;
}
.message-avatar--assistant {
  background: var(--p-surface-700);
  border: 1px solid var(--chat-border);
  box-shadow: var(--chat-bubble-shadow);
}
.message-avatar--assistant img {
  width: 1.35rem;
  height: 1.35rem;
  object-fit: contain;
}
.message-avatar--user {
  background: var(--chat-primary);
  color: var(--chat-primary-text);
}
.message-bubble {
  padding: 0.75rem 0.9rem;
  border-radius: 1.125rem;
  box-shadow: var(--chat-bubble-shadow);
  max-width: 100%;
}
.message-row--assistant .message-bubble {
  background: var(--chat-surface);
  border: 1px solid var(--chat-border);
  border-bottom-left-radius: 0.35rem;
  color: var(--chat-text);
}
.message-row--user .message-bubble {
  background: var(--chat-primary);
  color: var(--chat-primary-text);
  border-bottom-right-radius: 0.35rem;
  box-shadow: 0 4px 14px color-mix(in srgb, var(--chat-primary) 35%, transparent);
}
.message-bubble--loading {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  background: var(--chat-surface);
  border: 1px solid var(--chat-border);
  border-bottom-left-radius: 0.35rem;
  color: var(--chat-text);
}
.message-text {
  font-size: 0.9375rem;
  line-height: 1.55;
  word-break: break-word;
}
.message-text strong {
  font-weight: 600;
}
.message-text code {
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
  font-size: 0.84em;
  padding: 0.12rem 0.35rem;
  border-radius: 0.35rem;
  background: var(--chat-code-bg);
}
.message-row--user .message-text code {
  background: var(--chat-user-code-bg);
}
.message-time {
  display: block;
  margin-top: 0.4rem;
  font-size: 0.6875rem;
  color: var(--chat-text-muted);
}
.message-row--user .message-time {
  color: color-mix(in srgb, var(--chat-primary-text) 72%, transparent);
}
.typing-indicator {
  display: flex;
  gap: 0.3rem;
}
.typing-indicator span {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: var(--chat-primary);
  animation: typing-bounce 1.2s ease-in-out infinite;
}
.typing-indicator span:nth-child(2) {
  animation-delay: 0.15s;
}
.typing-indicator span:nth-child(3) {
  animation-delay: 0.3s;
}
.typing-label {
  font-size: 0.8125rem;
  color: var(--chat-text-muted);
}
.chat-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0.875rem;
  padding: 0.625rem 0.75rem;
  border-radius: var(--chat-radius);
  background: var(--chat-error-bg);
  border: 1px solid var(--chat-error-border);
  color: var(--chat-error-text);
  flex-shrink: 0;
}
.chat-error .chat-error-text {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.4;
}
.chat-composer {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  padding: 0.875rem 1rem 1rem;
  background: var(--chat-surface);
  border-top: 1px solid var(--chat-border);
  flex-shrink: 0;
}
.composer-input {
  flex: 1;
  min-height: 2.75rem;
  max-height: 8rem;
  resize: none;
  border-radius: 1.25rem !important;
  padding: 0.7rem 1rem !important;
  font-size: 0.9375rem;
  line-height: 1.45;
  color: var(--chat-text) !important;
  background: var(--chat-muted) !important;
  border: 1px solid var(--chat-border) !important;
  box-shadow: none !important;
  transition: border-color var(--transition-duration) ease, box-shadow var(--transition-duration) ease;
}
.composer-input::placeholder {
  color: var(--chat-text-muted);
}
.composer-input:focus {
  border-color: var(--chat-primary) !important;
  box-shadow: var(--focus-ring-shadow) !important;
}
.composer-input:disabled {
  opacity: 0.6;
  background: var(--chat-hover) !important;
}
:host ::ng-deep .composer-send.p-button {
  width: 2.75rem;
  height: 2.75rem;
  flex-shrink: 0;
}
@keyframes message-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes typing-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .message-row {
    animation: none;
  }
  .typing-indicator span {
    animation: none;
    opacity: 0.7;
  }
}
/*# sourceMappingURL=chat.component.css.map */
